export default __webpack_public_path__ + "static/media/fflogo.72fbe4df.svg";